import React from 'react';
import { ITaxState } from '../../../../types/taxes/taxesTypes';
import { TableCell, TableRow } from '@mui/material';
import DotIcon from '../../../components/DotIcon';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import {
    categorizePeriod,
    formatDate,
    isDateless,
} from '../../../../utils/formatDates';
import Tag from '../../../../muiComponents/Tag';
import { TAX_DATE_TAG_COLOR } from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import routes from '../../../../utils/commonVariables/routes';
import SupplierTaxTypeIcon from '../taxTypesIcons/SupplierTaxTypeIcon';
import SupplierTaxCalculationTypeIcon from '../taxTypesIcons/SupplierTaxCalculationTypeIcon';
import SupplierTaxCalculationRuleTypeSubjectIcon from '../taxTypesIcons/SupplierTaxCalculationRuleTypeIcon';

const TaxRow = ({ tax }: { tax: ITaxState }) => {
    const { setSearchParam } = useSearchParams({ base64: true });

    const handleRowClick = (idTax: string) => {
        setSearchParam('id', idTax);
    };

    const isDatelessTax = isDateless(tax.FromDate) && isDateless(tax.ToDate);
    const tagText = categorizePeriod(tax.FromDate, tax.ToDate);

    const linkToHotel = routes.propertyDetail(tax.IdSupplierHotel);

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(tax.Id)}
        >
            <TableCell>
                <div className='flex-center'>
                    <DotIcon truthy={tax.Enabled} />
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <h6 className='tax__title'>{tax.Name}</h6>

                <Tooltip title={tax.Description || ''}>
                    <p className='tax__description text-preline'>
                        {tax.Description || ''}
                    </p>
                </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                <Tooltip titleText='navigate_to_hotel_detail'>
                    <h6
                        className='tax__title link-onhover'
                        onClick={e => {
                            e.stopPropagation();
                            window.open(linkToHotel, linkToHotel);
                        }}
                    >
                        {tax.SupplierHotel}
                    </h6>
                </Tooltip>
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {tax.SupplierHotelRoomType}
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {tax.SupplierHotelMealPlan}
            </TableCell>
            <TableCell style={{ minWidth: 180 }}>
                {tax.SupplierHotelRatePlan}
            </TableCell>
            <TableCell>
                <div className='flex gap-10 '>
                    <SupplierTaxTypeIcon
                        entityKey={tax.SupplierTaxTypeKey}
                        text={tax.SupplierTaxType}
                    />
                    <SupplierTaxCalculationTypeIcon
                        entityKey={tax.SupplierTaxCalculationTypeKey}
                        text={tax.SupplierTaxCalculationType}
                    />
                    <SupplierTaxCalculationRuleTypeSubjectIcon
                        entityKey={tax.SupplierTaxCalculationRuleTypeKey}
                        type='subject'
                    />
                    <SupplierTaxCalculationRuleTypeSubjectIcon
                        entityKey={tax.SupplierTaxCalculationRuleTypeKey}
                        type='frequency'
                    />
                </div>
            </TableCell>
            <TableCell style={{ minWidth: 200 }}>
                {!isDatelessTax ? (
                    <div className='flex-column flex-align-end gap-10 height100perc flex-between'>
                        {formatDate(tax.FromDate)} - {formatDate(tax.ToDate)}
                        <Tag
                            text={tagText}
                            color={TAX_DATE_TAG_COLOR[tagText]}
                        />
                    </div>
                ) : (
                    ''
                )}
            </TableCell>
        </TableRow>
    );
};

export default TaxRow;
